import { FC } from 'react'
import { Form, FormControlProps } from 'rsuite'

import TextBox from '../../../UI/Textarea'
import InputWrapper from './InputWrapper'

import styles from '../../../../styles/MultiStepModal.module.less'

interface TextInputProps extends FormControlProps<HTMLInputElement> {
  label?: string
  subLabel?: string
  placeholder?: string
  isTextBox?: boolean
  type?: HTMLInputElement['type']
}

const TextInput: FC<TextInputProps> = ({
  type = 'text',
  isTextBox,
  name,
  accepter,
  label,
  subLabel,
  children,
  className,
  ...rest
}) => (
  <InputWrapper
    controlId={name}
    label={label || ''}
    subLabel={subLabel}
    className={className}
  >
    {children}
    <Form.Control
      name={name}
      accepter={isTextBox ? TextBox : accepter}
      className={isTextBox ? styles['textarea-input'] : ''}
      type={type}
      {...rest}
    />
  </InputWrapper>
)

export default TextInput
